var _defs, _defs2, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoast(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    "aria-hidden": "true",
    viewBox: "0 0 520 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 175.23,
    x2: 175.23,
    y1: 172.92,
    y2: 62.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#570732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#610b39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#79164b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#8c1e59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#9a2463"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#a22768"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a4286a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 476.05,
    x2: 476.05,
    y1: 194.48,
    y2: 36.51,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 287.15,
    x2: 287.15,
    y1: 172.55,
    y2: 61.84,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 390.54,
    x2: 390.54,
    y1: 172.99,
    y2: 61.27,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 76.15,
    x2: 76.15,
    y1: 3.2,
    y2: 178.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#77b227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#75b027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#6eab27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#63a027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#529228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#3c8028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#246b29"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M175.31 62.17c-38.63 0-54.09 25.93-54.09 54.81 0 30 15.23 55.94 54.09 55.94s54-27.15 53.93-54.18c-.09-32.92-16.75-56.57-53.93-56.57zm-23.41 56.44C152.84 80 182.52 80 192.43 93.85c9 12.62 10.89 55.74-17.12 55.42-12.9-.14-23.03-8.86-23.41-30.66z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M488.68 146.13v-56h20V65.86h-20V36.51h-30.9v29.35H442.1v24.29h15.68V143c0 30 20.92 47.84 43 51.53l9.22-24.9c-12.87-1.63-21.2-11.25-21.32-23.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M332.75 137.26V95.19a43.87 43.87 0 00-.24-4.39c-2.68-34-50.95-33.92-88.34-20.87L255 91.68c24.35-11.56 38.92-8.58 44-2.88.13.15.26.29.38.45a.21.21 0 000 .06c2.6 3.5 2 9 2 13.38-31.81 0-65.67 4.23-65.67 39.12 0 26.53 33.23 43.59 68 18.31l5.16 12.43h29.76c-2.7-14.55-5.88-27.1-5.88-35.29zm-31.13-.26c-24.48 27.39-46.89 1.61-23.94-9.64 6.76-2.3 15.93-2.4 23.94-2.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M380.25 92.92c0-10.36 16.6-15.21 42.77-3.26l9.05-22C396.85 57 348.75 56.08 348.43 92.92c-.14 17.66 11.18 27.16 27.49 33.22 11.29 4.2 27.6 6.37 27.55 15.37-.06 11.75-25.34 13.55-48.35-2.26l-9.3 23.84c31.38 15.62 89.75 16.06 89.44-23.09-.26-38.7-55.01-32.07-55.01-47.08z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M108.16 9.16l-44.8 124.43L41.91 66.4H10l35.72 91.76a33.41 33.41 0 010 24.3c-4 10.24-10.64 19-26.83 21.18v27.2c31.53 0 48.58-19.38 63.79-61.87L142.3 9.16z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoast);
export default __webpack_public_path__ + "static/media/yoast.1727c424a25e733b0a615dce2c7c2ad1.svg";
export { ForwardRef as ReactComponent };